import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProductListComponent } from './product-list/product-list.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ProductListResolver } from './product-list/product-list.resolver';
import { ProductDetailResolver } from './product-detail/product-detail.resolver';
import { ProductListSearchResolver } from './product-list/product-list-search.resolver';
import { ProductSearchComponent } from './product-search/product-search.component';
import { ProductSaleComponent } from './product-sale/product-sale.component';

const routes: Routes = [
  {
    path: '',
    children: [{
      path: ':categoryId',
      component: ProductListComponent,
      data: { title: 'Category', breadcrumb: 'Category' },
      resolve: { 
        products: ProductListResolver
      }
    }, {
      path: ':categoryId/detail/:productId',
      component: ProductDetailComponent,
      data: { title: 'Product', breadcrumb: 'Product' },
      resolve: { 
        product: ProductDetailResolver
      }
    }, {
      path: 'search/:keyword',
      component: ProductSearchComponent,
      data: { title: 'Search', breadcrumb: 'Search' },
      resolve: { 
        products: ProductListSearchResolver
      }
    }, {
      path: 'search/:keyword/detail/:productId',
      component: ProductDetailComponent,
      data: { title: 'Product', breadcrumb: 'Product' },
      resolve: { 
        product: ProductDetailResolver
      }
    }, {
      path: 'sale/page',
      component: ProductSaleComponent,
      data: { title: 'Product', breadcrumb: 'Product' },
    }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductRoutingModule { }
